import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsDoneWorks(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_DONE_WORKS,dtConfig[ModulesMap.REPORTS_DONE_WORKS].getReportsDoneWorks,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		}
	)
}
function getReportsDoneWork(companyId, doneWorksId, data) {
	return dataTransferWrap(
		ModulesMap.REPORTS_DONE_WORKS,dtConfig[ModulesMap.REPORTS_DONE_WORKS].getReportsDoneWork,
		{
			urlParams: {
				companyId: companyId,

				doneWorksId,
			},
	...data,
		}
	)
}
function getReportsDoneWorkPreview(companyId, doneWorksId, data) {
	return dataTransferWrap(
		ModulesMap.REPORTS_DONE_WORKS,dtConfig[ModulesMap.REPORTS_DONE_WORKS].getReportsDoneWorkPreview,
		{
			urlParams: {
				companyId: companyId,

				doneWorksId,
			},
	...data,
		}
	)
}

export default {
	getReportsDoneWorks,
	getReportsDoneWork,
	getReportsDoneWorkPreview,
}
